<template>
    <div class="container-fluid">
        <!-- HEADER -->
        <div class="view-header my-4">
            <div class="view-header__main">
                <div class="view-header__info">
                    <h1 class="view-header__title">Pago a proveedores</h1>
                    <p class="view-header__subtitle">Gestioná pagos, órdenes de pago e imputaciones de la cuenta corriente del proveedor.</p>
                </div>
            </div>
        </div>

        <!-- FILTROS -->
        <div class="filters-panel">
            <div class="filters-panel__section">
                <div class="filters-panel__section-title">
                    <i class="bi bi-search"></i>
                    Buscador
                </div>
                <div class="filters-panel__row">
                    <div class="filters-panel__field">
                        <label class="control-label">Proveedor</label>
                        <typeahead
                        :name="'provider'"
                        :placeh="'Busqueda de proveedor por nombre'"
                        :clean-on="false"
                        v-on:choosed="providerUpdate"
                        v-on:empty="providerEmpty"
                        :default="'null'"
                        :externalsrc="'/api/providers/getProviders'"
                        limit-chars="4"/>
                    </div>
                    <div class="filters-panel__field">
                        <label class="control-label">Desde</label>
                        <datepicker-component v-on:datechoosed="fromDateUpdated" :dateLabel="'Seleccione una fecha'"/>
                    </div>
                    <div class="filters-panel__field">
                        <label class="control-label">Hasta</label>
                        <datepicker-component v-on:datechoosed="toDateUpdated"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- TABS -->
        <ul class="nav product-tabs">
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 0 }" href="#" @click.prevent="activeTab = 0">
                    <i class="bi bi-cash-stack"></i> Pagos
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 1 }" href="#" @click.prevent="activeTab = 1">
                    <i class="bi bi-receipt"></i> Ord. de pago
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab == 2 }" href="#" @click.prevent="activeTab = 2">
                    <i class="bi bi-diagram-3"></i> Imputaciones
                </a>
            </li>
        </ul>

        <!-- PESTAÑA PAGOS -->
        <template v-if="activeTab == 0">
            <div v-if="payload.header.provider_id" class="row">
                <div class="col-md-4">
                    <div class="stats-card">
                        <div class="stats-card__value">{{ balanceText }}</div>
                        <div class="stats-card__label">Saldo en cuenta corriente</div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="stats-card">
                        <div class="stats-card__value" :class="{ 'stats-card__value--danger': concilValue < 0 }">{{ concilText }}</div>
                        <div class="stats-card__label">Conciliación</div>
                    </div>
                </div>
                <div class="col-md-4 d-flex align-items-center justify-content-center">
                    <label class="d-inline-flex align-items-center mb-0" style="gap: 8px; cursor: pointer;">
                        <input type="checkbox" v-model="historical">
                        <span>Mostrar histórico</span>
                    </label>
                </div>
            </div>
            <div v-else class="stats-card">
                <div class="stats-card__label">Buscá un proveedor para ver la información</div>
            </div>

            <!-- TOOLBAR -->
            <div class="d-flex justify-content-end mb-3" style="gap: 8px;">
                <button type="button" id="allocation-btn" class="btn view-header__btn" @click="checkAllocations()">
                    <i class="bi bi-link-45deg"></i>
                    Imputar
                </button>
                <button type="button" class="btn view-header__btn view-header__btn--primary" :disabled="!payload.header.provider_id" @click="ifModalPayment()">
                    <i class="bi bi-plus-lg"></i>
                    Nueva orden de pago
                </button>
            </div>

            <div class="row">
                <!-- FACTURAS -->
                <div class="col-md-6">
                    <div v-if="tableDocFields.length > 0" class="mb-2">
                        <input v-model="docFilter" class="form-control" placeholder="Buscar por factura...">
                    </div>
                    <div class="data-table">
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" v-model="selectAllDocs"></th>
                                        <th>Fecha</th>
                                        <th>Factura</th>
                                        <th class="text-right">Deuda</th>
                                        <th class="text-right">Saldo</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(doc, index) in tableDocFieldsFiltered" :key="index" :class="[{ selected: doc.rowSelected }, { verde: doc.payment }, { azul: doc.historical }]">
                                        <td>
                                            <input type="checkbox" v-model="selectedDocs" :value="doc" @click="selectRow($event, doc)">
                                        </td>
                                        <td>{{ doc.date }}</td>
                                        <td>{{ doc.docname }}</td>
                                        <td class="text-right">{{ formatoDinamicoMoneda(doc.value) }}</td>
                                        <td class="text-right">{{ formatoDinamicoMoneda(doc.debt) }}</td>
                                        <td class="text-right">
                                            <div v-if="doc.docname != 'SALDO INICIAL'" class="table-action-group">
                                                <router-link class="table-action-btn" :to="'/compras/index/detalle/' + doc.purchase_id" title="Ver detalle">
                                                    <i class="bi bi-eye"></i>
                                                </router-link>
                                                <button type="button" class="table-action-btn" title="Anular comprobante" @click="cancelPurchase(doc.purchase_id)">
                                                    <i class="bi bi-x-circle"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="tableDocFieldsFiltered.length === 0">
                                        <td colspan="6" class="data-table__empty">Sin comprobantes para mostrar</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- ORDENES DE PAGO -->
                <div class="col-md-6">
                    <div v-if="tablePayFields.length > 0" class="mb-2">
                        <input v-model="payFilter" class="form-control" placeholder="Buscar por orden de pago...">
                    </div>
                    <div class="data-table">
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" v-model="selectAllPays"></th>
                                        <th>Fecha</th>
                                        <th>Número</th>
                                        <th class="text-right">Valor</th>
                                        <th class="text-right">Saldo</th>
                                        <th class="text-right">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(po, index) in tablePayFieldsFiltered" :key="index" :class="[{ selected: po.rowSelected }, { azul: po.historical }]">
                                        <td>
                                            <input type="checkbox" v-model="selectedPays" :value="po" @click="selectRow($event, po)">
                                        </td>
                                        <td>{{ po.date }}</td>
                                        <td>{{ po.payorder }}</td>
                                        <td class="text-right">{{ formatoDinamicoMoneda(po.value) }}</td>
                                        <td class="text-right">{{ formatoDinamicoMoneda(po.rest) }}</td>
                                        <td class="text-right">
                                            <div class="table-action-group">
                                                <a class="table-action-btn" :href="'/compras/detalle-orden-de-pago/' + po.po_id" title="Ver detalle">
                                                    <i class="bi bi-eye"></i>
                                                </a>
                                                <button type="button" class="table-action-btn" title="Cancelar orden" @click="cancelPayorder(po.id)">
                                                    <i class="bi bi-x-circle"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="tablePayFieldsFiltered.length === 0">
                                        <td colspan="6" class="data-table__empty">Sin órdenes de pago para mostrar</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- PESTAÑA ORD. DE PAGO -->
        <payorders-table
        v-if="activeTab == 1"
        :provider="payload.header.provider_id"
        :fromDate="fromDate"
        :toDate="toDate"
        :watchTarget="tablePayFields"
        v-on:cancelPay="cancelPayorder"/>

        <!-- PESTAÑA IMPUTACIONES -->
        <allocations-table
        v-if="activeTab == 2"
        v-on:allocationDeleted="refreshTables"
        :provider="payload.header.provider_id"
        :fromDate="fromDate"
        :toDate="toDate"/>

        <pay-order-payment-methods
            :header="payload.header"
            :fundDefault="config.fund_default"
            :emisionData="config.emisionData"
            v-on:paymentmethodschanged="paymentMethodsUpdated"
            v-on:paymentmethodsclose="paymentMethodsClose"
            v-bind:payment-methods="payment_methods"
            v-bind:total="concilValue"
            v-if="showModal"
            :limited="false"
            :checks='wallet'
            @close="showModal = false"/>

    </div>
</template>


<script>

import payOrderPaymentMethods from '../../paymentmethods/Pay-order-payment-methods.vue';
import typeahead from '../../global/Typeahead.vue';
import datepickerComponent from '../../global/Datepicker-empty.vue';
import payordersTable from './Ordenes-de-pago.vue';
import allocationsTable from './Imputaciones.vue';
import formatDateMixin from "../../../mixins/formatDateMixin";
import formatMoneyMixin from "../../../mixins/formatMoneyMixin";

import { mapState } from 'vuex'

export default {
  components: {
    payOrderPaymentMethods,
    typeahead,
    datepickerComponent,
    payordersTable,
    allocationsTable
  },
  mixins: [formatDateMixin,formatMoneyMixin],
    data() {
        return {
            activeTab: 0,
            showModal: false,
            wallet: null,
            payload: {
            header: {
                provider_id : null,
                pos: 0
            },
            paymentMethods: []
            },
            fromDate: null,
            toDate:null,
            historical: null,
            concilValue: 0.00,
            balanceValue:0.00,
            tableDocFields:[],
            tablePayFields:[],
            selectedDocs:[],
            selectedPays:[],
            docFilter:'',
            payFilter:'',
            printURL:'',
            payment_methods:null
        }
    },
    mounted() {
        this.historical=false;
        this.testDocs=true;
    },
    created () {
        this.$store.dispatch('authUser/getAuthUser')
    },
    computed: {
        ...mapState('authUser',{
            authUser: state => state.authUser,
        }),
        
        config: {
            get: function () { return  this.authUser.branchoffices[0].configs;}
        },
        branchofficeData:{
            get: function () { 
            return {
                'name' : this.authUser.branchoffices[0].name,
                'bsns_name' : this.authUser.branchoffices[0].business_name,
                'cuit' : this.authUser.branchoffices[0].cuit,
            }
            }
        },
        concilText: {
            get: function () {
                return '$ ' + this.concilValue.toFixed(2).replace(".",",").replace(/\d(?=(\d{3})+,)/g, '$&.');
            }
        },
        balanceText: {
            get: function () {
                return '$ ' + this.balanceValue.toFixed(2).replace(".",",").replace(/\d(?=(\d{3})+,)/g, '$&.');
            }
        },

        selectAllDocs: {
            get: function () {
                if((this.selectedDocs.length == this.tableDocFields.length) && (this.tableDocFields.length!=0)){
                    return true;
                }else{
                    return false;
                }
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    for (var doc in this.tableDocFields) {
                        this.tableDocFields[doc].rowSelected =true;
                        this.selectedDocs.push(this.tableDocFields[doc]);
                    }
                }else{
                    for (doc in this.tableDocFields) {
                        this.tableDocFields[doc].rowSelected =false;
                    }
                    this.selectedDocs = selected;
                }
            }
        },
        selectAllPays: {
            get: function () {
                if ((this.selectedPays.length == this.tablePayFields.length) && (this.tablePayFields.length!=0)){
                    return true;
                }else{
                    return false;
                }
            },
            set: function (value) {
                var selected = [];

                if (value) {
                    for (var pay in this.tablePayFields) {
                        this.tablePayFields[pay].rowSelected =true;
                        this.selectedPays.push(this.tablePayFields[pay]);
                    }
                }else{
                    for (pay in this.tablePayFields) {
                        this.tablePayFields[pay].rowSelected =false;
                    }
                    this.selectedPays=selected;
                }
            }
        },
        tableDocFieldsFiltered:{
            get: function () {
                let vm = this;
                return this.tableDocFields.filter(e => e.docname.includes(vm.docFilter));
            }
        },
        tablePayFieldsFiltered:{
            get: function () {
                let vm = this;
                return this.tablePayFields.filter(e => e.payorder.includes(vm.payFilter));
            }
        }
    },
  watch: {
      'selectedDocs': {
          handler: function () {this.updateConcilValue();}
      },
      'selectedPays': {
          handler: function () {this.updateConcilValue();}
      },
      'historical': {
          handler: function () {this.refreshTables();}
      },
      authUser: function(value) {
        if(value==null) return;
        this.payment_methods = Object.assign({}, this.authUser.branchoffices[0].payments_methods);
        this.payment_methods.cuenta_corriente=0;

      },
    
  },

  methods: {
    SwitchTab() {
        this.activeTab = 1
    },
    fromDateUpdated: function (date) {
      this.fromDate = date;
      this.refreshTables();
    },
    toDateUpdated: function (date) {
      this.toDate = date;
      this.refreshTables();
    },
    paymentMethodsUpdated(obj) {
        this.payload.paymentMethods=obj;
    },
    paymentMethodsClose(obj) {
        this.payload.paymentMethods=obj;
        if ((obj.cash >0) || (Number(obj.transfer) > 0) || (obj.accounts.length>0) || (obj.creditcards.length>0) || (obj.tpchecks.length>0) || (obj.sfchecks.length>0)){
            this.sendReceipt();
        }
    },
    sendReceipt() {
      var vm= this;
      var outdata = {
          'header': vm.payload.header,
          'paymentMethods' :vm.payload.paymentMethods,
          'selectedDocs' : vm.selectedDocs,
          'selectedPay' : vm.selectedPays,
        };
      this.concilValue = 0.00;
      axios.post('/api/payments/addAllocationPayment', outdata)
          .then((response) => {
            if (response.data.success) {
                if (response.data.data.printInvoice == true) {
                    window.open(response.data.data.urlInvoice, '_blank');
              } else {
                // no-op intencional
                
              }
              this.refreshTables();
            } else {
              // no-op intencional
              
            }
          }).catch((error) => {
            console.log('error: '+error);
          })
    },
    selectRow(event, item) {
        item.rowSelected = !item.rowSelected;
    },
    providerUpdate(data) {
      this.payload.header.provider_id=data.id;
      this.updateBalanceValue();
      this.refreshTables();
      this.selectedDocs=[];
      this.selectedPays=[];
    },
    providerEmpty(){
        this.payload.header.provider_id=null;
        this.refreshTables();
        this.selectedDocs=[];
        this.selectedPays=[];
    },
    getProvidersList(){
        var vm = this;
        axios.get('/api/providers/list')
            .then(response => {
              if(response.data) {
                vm.providerList = response.data.data;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    refreshTables(){
        var vm= this;
        var outdata = {
            'provider_id': vm.payload.header.provider_id,
            'historical' : vm.historical,
            'posFilter':vm.posFilter,
            'fromDate':vm.fromDate,
            'toDate':vm.toDate
        };
        axios.post('/api/payments/getListPurchases', outdata)
            .then(response => {
              if(response.data) {
                vm.tableDocFields = response.data;
              }
            })
            .catch(error => {
              alert(error);
            })

        axios.post('/api/payments/getListPayorders', outdata)
            .then(response => {
              if(response.data) {
                vm.tablePayFields = response.data;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    updateConcilValue(){
        var vm=this;
        var outdata ={
            'provider': vm.payload.header.provider_id,
            'selectedDocs' : vm.selectedDocs,
            'selectedPay' : vm.selectedPays
        };

        axios.post('/api/payments/getConciliation', outdata)
            .then(response => {
              if(response.data.data) {
                vm.concilValue = parseFloat(response.data.data);
              }else{
                vm.concilValue = 0.00;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    updateBalanceValue(){
        var vm=this;
        axios.get('/api/providers/getBalance/' +  vm.payload.header.provider_id)
            .then(response => {
              if(response.data.data) {
                vm.balanceValue = parseFloat(response.data.data);
              }else{
                vm.balanceValue = 0.00;
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    checkAllocations(){
        if (this.selectedDocs.length<=0){
            alert("Necesita seleccionar comprobantes");
            return false;
        }

        if (confirm("Se realizará la imputación indicada")){
            if (this.concilValue>0){
                if(confirm("El pago no es suficiente para cubrir los comprobantes seleccionados ¿Desea ingresar un pago por el monto restante ahora?")){
                    this.showModal = true;
                }else{
                    this.allocate();
                }
            }else{
                this.allocate();
            }
        }
    },
    allocate(){
        var vm=this;
        var outdata ={
            'provider': vm.payload.header.provider_id,
            'selectedDocs' : vm.selectedDocs,
            'selectedPay' : vm.selectedPays
        };

        axios.post('/api/payments/addAllocation', outdata)
            .then(response => {
              if(response.data.success) {
                  this.refreshTables();
              }else{
                // no-op intencional
                  
              }
            })
            .catch(error => {
              alert(error);
            })
    },
    ifModalPayment(){
        if (this.concilValue>=0){ this.showModal = true;
        }else{ alert("No se pueden crear pagos con valor negativo");}
    },
    cancelPayorder(data){
        if (confirm("¿Está seguro que desea eliminar este comprobante? Se desarmarán también todas las imputaciones en las que se encuentre asociado")){
            axios.get('/api/payments/cancelPayorder/'+data)
            .then(response => {
                if(response.data.success) {
                  this.refreshTables();
                }else{
                  alert(response.message);
                }
            })
            .catch(error => {
              alert(error.message);
            })
        }
    },
    cancelPurchase(id){
        var outdata={'id':id};
        if (confirm("¿Está seguro que desea anular este comprobante? No aparecerá en el listado de pago a proveedores pero podrá verse en la vista de compras")){
            axios.post('/api/purchases/cancel',outdata)
            .then(response => {
                if(response.data.success) {
                  this.refreshTables();
                }else{
                  alert(response.message);
                }
            })
            .catch(error => {
              alert(error.message);
            })
        }
    }
  },
}
</script>   
